import { gtagEvent } from "../lib/gtag";
import type {
  PageViewEventParams,
  WidgetInteractionParams,
  ReportExportParams,
  DealerChangedParams,
  DateRangeChangedParams,
  WidgetCreatedParams,
  AiInsightsOpenedParams,
  PageCreatedParams,
  LoginEventParams,
} from "../types";

/** @internal — prefer <PageViewTracker /> over calling this directly */
export function firePageView(params: PageViewEventParams): void {
  gtagEvent("page_view", params);
}

export function fireWidgetInteraction(params: WidgetInteractionParams): void {
  gtagEvent("widget_interaction", params);
}

export function fireReportExport(params: ReportExportParams): void {
  gtagEvent("report_export", params);
}

export function fireDealerChanged(params: DealerChangedParams): void {
  gtagEvent("dealer_changed", params);
}

export function fireDateRangeChanged(params: DateRangeChangedParams): void {
  gtagEvent("date_range_changed", params);
}

export function fireWidgetCreated(params: WidgetCreatedParams): void {
  gtagEvent("widget_created", params);
}

export function fireAiInsightsOpened(params: AiInsightsOpenedParams): void {
  gtagEvent("ai_insights_opened", params);
}

export function firePageCreated(params: PageCreatedParams): void {
  gtagEvent("page_created", params);
}

export function fireLogin(params: LoginEventParams): void {
  gtagEvent("login", params);
}
